import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politique-confidentialite',
  templateUrl: './politique-confidentialite.component.html',
  styleUrls: ['./politique-confidentialite.component.scss']
})
export class PolitiqueConfidentialiteComponent implements OnInit {
  
  lastUpdateDate: string = 'Janvier 2025';

  currentYear = new Date().getFullYear();


  constructor() { }

  ngOnInit(): void {
    // Scroll to top on component init
    window.scrollTo(0, 0);
  }
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; // Offset for fixed header
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}